import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Two similar triangles with a scale factor controlled by a slider.
 */
export const SIMILARITY_CHAIN_PRESET: GeometryPadWidgetConfig = {
  id: 'similarity-chain',
  type: 'geometrypad',
  params: {
    variables: { k: 1.5 },
    elements: {
      t1: {
        type: 'Triangle',
        params: { a: 4, b: 6, gamma: 50 },
      },
      t2: {
        type: 'Triangle',
        params: { a: 'k * 4', b: 'k * 6', gamma: 50 },
      },
    },
  },
  display: {
    geometry: {
      label: { coloring: true },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-k',
        type: 'slider',
        label: 'Scale k',
        param: 'k',
        range: [0.5, 3, 0.1],
        defaultValue: 1.5,
        editable: true,
        color: 'sky',
      },
    ],
  },
};
